module.exports = __webpack_public_path__ + "static/img/2bg_13.caed854.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_13.png
// module id = 673
// module chunks = 1